<template>
  <div>
    <!-- Directive -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          {{ $t("DIRECTIVE") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-textarea
          :spellcheck="false"
          dense
          outlined
          rows="3"
          v-model="formGeneral.leadSentence"
          :error-messages="leadSentenceErrors"
          @input="$v.formGeneral.leadSentence.$touch()"
          @blur="$v.formGeneral.leadSentence.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Void data all -->
    <v-row>
      <v-col cols="4" class="pa-0" style="max-width: 220px; min-width: 220px">
        <label class="font-weight-bold">
          {{ $t("LISTEN_ALL_VOICE_DATA") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="py-0">
        <v-row class="ma-0">
          <v-col class="pa-0">
            <v-icon class="ml-2 mt-2" v-if="!formGeneral.audio" tag="p"
              >fas fa-volume-off</v-icon
            >
            <audio
              class="ml-3"
              id="Audio"
              controls
              v-if="formGeneral.audio && formGeneral.audio.fileUrl"
              :key="keyAudio"
            >
              <source :src="formGeneral.audio.fileUrl" type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
            <div
              v-if="
                audioError && (!formGeneral.audio || !formGeneral.audio.fileUrl)
              "
            >
              <div class="v-messages theme--light error--text" role="alert">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">
                    音声データを選択ください。
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col class="d-flex pa-0">
            <v-spacer />
            <base-upload type="audio" v-model="formGeneral.audio">
              <span slot="activator">
                <v-btn class="primary" height="40px">{{
                  $t("FILE_SELECT")
                }}</v-btn>
              </span>
            </base-upload>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Script or void data all  -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          台本
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-textarea
          :spellcheck="false"
          dense
          outlined
          rows="2"
          v-model="formGeneral.script"
          :error-messages="scriptErrors"
          @input="$v.formGeneral.script.$touch()"
          @blur="$v.formGeneral.script.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Void data question 1 -->
    <v-row>
      <v-col cols="4" class="col-lable py-0">
        <label class="font-weight-bold">{{
          $t("QUESTIONS", { NUMBER: 1 })
        }}</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="col-lable py-0">
        <label class="font-weight-bold">
          {{ $t("VOID_DATA") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="py-0">
        <v-row class="ma-0">
          <v-col class="pa-0">
            <v-icon
              class="ml-2 mt-2"
              v-if="!formGeneral.sub_question.question1.audio"
              tag="p"
              >fas fa-volume-off</v-icon
            >
            <audio
              class="ml-3"
              id="Audio"
              controls
              v-if="
                formGeneral.sub_question.question1.audio &&
                formGeneral.sub_question.question1.audio.fileUrl
              "
              :key="keyAudioQuestion1"
            >
              <source
                :src="formGeneral.sub_question.question1.audio.fileUrl"
                type="audio/mp3"
              />
              Your browser does not support the audio element.
            </audio>
            <div
              v-if="
                audioQuestion1Error &&
                (!formGeneral.sub_question.question1.audio ||
                  !formGeneral.sub_question.question1.audio.fileUrl)
              "
            >
              <div class="v-messages theme--light error--text" role="alert">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">
                    音声データを選択ください。
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col class="d-flex pa-0">
            <v-spacer />
            <base-upload
              type="audio"
              v-model="formGeneral.sub_question.question1.audio"
            >
              <span slot="activator">
                <v-btn class="primary" height="40px">{{
                  $t("FILE_SELECT")
                }}</v-btn>
              </span>
            </base-upload>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Script or void data question 1  -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          台本
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-textarea
          :spellcheck="false"
          dense
          outlined
          rows="2"
          v-model="formGeneral.sub_question.question1.script"
          :error-messages="scriptQuestion1Errors"
          @input="$v.formGeneral.sub_question.question1.script.$touch()"
          @blur="$v.formGeneral.sub_question.question1.script.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Answer question 1 -->
    <v-row>
      <v-col cols="4" class="col-lable"></v-col>
      <v-col class="pa-1">
        <v-row>
          <v-col
            class="pl-2 py-0"
            cols="6"
            v-for="(item, index) in $v.formGeneral.sub_question.question1
              .answers.$each.$iter"
            :key="item.id"
          >
            <v-radio-group
              hide-details
              class="mt-5"
              v-model="formGeneral.sub_question.question1.isAnsewr"
              :mandatory="false"
            >
              <v-text-field
                class="ml-1"
                v-model="item.value.$model"
                :error-messages="answersErrors(item.value)"
                @input="item.value.$touch()"
                @blur="item.value.$touch()"
                :style="
                  index % 2 == 0 ? 'margin-right:2.4rem' : 'margin-left:2.2rem'
                "
                dense
                outlined
              >
                <template v-slot:prepend>
                  <v-radio :value="item.$model.id"></v-radio>
                </template>
                <template v-slot:label>
                  <h3>
                    {{ item.$model.name }}
                    <span class="red--text">*</span>
                  </h3>
                </template>
              </v-text-field>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Void data question 2 -->
    <v-row>
      <v-col cols="4" class="col-lable py-0">
        <label class="font-weight-bold">{{
          $t("QUESTIONS", { NUMBER: 2 })
        }}</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" class="col-lable py-0">
        <label class="font-weight-bold">
          {{ $t("VOID_DATA") }}
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="py-0">
        <v-row class="ma-0">
          <v-col class="pa-0">
            <v-icon
              class="ml-2 mt-2"
              v-if="!formGeneral.sub_question.question2.audio"
              tag="p"
              >fas fa-volume-off</v-icon
            >
            <audio
              class="ml-3"
              id="Audio"
              controls
              v-if="
                formGeneral.sub_question.question2.audio &&
                formGeneral.sub_question.question2.audio.fileUrl
              "
              :key="keyAudioQuestion2"
            >
              <source
                :src="formGeneral.sub_question.question2.audio.fileUrl"
                type="audio/mp3"
              />
              Your browser does not support the audio element.
            </audio>
            <div
              v-if="
                audioQuestion2Error &&
                (!formGeneral.sub_question.question2.audio ||
                  !formGeneral.sub_question.question2.audio.fileUrl)
              "
            >
              <div class="v-messages theme--light error--text" role="alert">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">
                    音声データを選択ください。
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col class="d-flex pa-0">
            <v-spacer />
            <base-upload
              type="audio"
              v-model="formGeneral.sub_question.question2.audio"
            >
              <span slot="activator">
                <v-btn class="primary" height="40px">{{
                  $t("FILE_SELECT")
                }}</v-btn>
              </span>
            </base-upload>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Script or void data question 2  -->
    <v-row>
      <v-col cols="4" class="py-0 col-lable">
        <label class="font-weight-bold">
          台本
          <span class="red--text">*</span>
        </label>
      </v-col>
      <v-col class="pa-0">
        <v-textarea
          :spellcheck="false"
          dense
          outlined
          rows="2"
          v-model="formGeneral.sub_question.question2.script"
          :error-messages="scriptQuestion2Errors"
          @input="$v.formGeneral.sub_question.question2.script.$touch()"
          @blur="$v.formGeneral.sub_question.question2.script.$touch()"
        />
      </v-col>
    </v-row>
    <!-- Answer question 2 -->
    <v-row>
      <v-col cols="4" class="col-lable"></v-col>
      <v-col class="pa-0">
        <v-row>
          <v-col
            class="pl-2 py-0"
            cols="6"
            v-for="(item, index) in $v.formGeneral.sub_question.question2
              .answers.$each.$iter"
            :key="item.id"
          >
            <v-radio-group
              hide-details
              class="mt-5"
              v-model="formGeneral.sub_question.question2.isAnsewr"
              :mandatory="false"
            >
              <v-text-field
                class="ml-1"
                v-model="item.value.$model"
                :error-messages="answersErrors(item.value)"
                @input="item.value.$touch()"
                @blur="item.value.$touch()"
                :style="
                  index % 2 == 0 ? 'margin-right:2.4rem' : 'margin-left:2.2rem'
                "
                dense
                outlined
              >
                <template v-slot:prepend>
                  <v-radio :value="item.$model.id"></v-radio>
                </template>
                <template v-slot:label>
                  <h3>
                    {{ item.$model.name }}
                    <span class="red--text">*</span>
                  </h3>
                </template>
              </v-text-field>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "FormShortSentences",
  mixins: [validationMixin],
  props: ["parent"],
  store: ["formGeneral"],
  validations: {
    formGeneral: {
      sub_question: {
        question1: {
          required,
          script: { required },
          answers: {
            required,
            $each: {
              value: {
                required,
                strongAnswers(answers) {
                  return !this.format.test(answers); // checks for special char
                },
              },
            },
          },
        },
        question2: {
          required,
          script: { required },
          answers: {
            required,
            $each: {
              value: {
                required,
                strongAnswers(answers) {
                  return !this.format.test(answers); // checks for special char
                },
              },
            },
          },
        },
      },
      leadSentence: { required },
      script: { required },
    },
  },
  computed: {
    leadSentenceErrors() {
      const errors = [];
      if (!this.$v.formGeneral.leadSentence.$dirty) return errors;
      !this.$v.formGeneral.leadSentence.required &&
        errors.push("指示文を入力してください。");
      return errors;
    },
    scriptErrors() {
      const errors = [];
      if (!this.$v.formGeneral.script.$dirty) return errors;
      !this.$v.formGeneral.script.required &&
        errors.push("台本を入力してください。");
      return errors;
    },
    scriptQuestion1Errors() {
      const errors = [];
      if (!this.$v.formGeneral.sub_question.question1.script.$dirty)
        return errors;
      !this.$v.formGeneral.sub_question.question1.script.required &&
        errors.push("台本を入力してください。");
      return errors;
    },
    scriptQuestion2Errors() {
      const errors = [];
      if (!this.$v.formGeneral.sub_question.question2.script.$dirty)
        return errors;
      !this.$v.formGeneral.sub_question.question2.script.required &&
        errors.push("台本を入力してください。");
      return errors;
    },
  },
  mounted() {
    let update = this.$route.name.search("Update");
    if (update == -1) {
      this.formGeneral.leadSentence =
        "この問題では、はじめに はなしを きいてください。\nそれから 問題と こたえを きいて いちばん いいものを ひとつ えらんでください。";
    }
  },
  data() {
    return {
      format: /[^\u00BF-\u1FFF\u2C00-\uD7FF０-９Ａ-Ｚａ-ｚ_＿/／\s\w]/g,
      keyAudio: 0,
      keyAudioQuestion1: 0,
      keyAudioQuestion2: 0,
      audioError: false,
      audioQuestion1Error: false,
      audioQuestion2Error: false,
    };
  },
  watch: {
    "formGeneral.audio": function () {
      this.keyAudio++;
    },
    "formGeneral.sub_question.question1.audio": function () {
      this.keyAudioQuestion1++;
    },
    "formGeneral.sub_question.question2.audio": function () {
      this.keyAudioQuestion2++;
    },
  },
  methods: {
    async getParams() {
      this.$v.$touch();
      const { audio, leadSentence, isAnsewr, script } = this.formGeneral;
      const { question1, question2 } = this.formGeneral.sub_question;
      this.audioError = !audio || !audio.fileUrl ? true : false;
      this.audioQuestion1Error =
        !question1.audio || !question1.audio.fileUrl ? true : false;
      this.audioQuestion2Error =
        !question2.audio || !question2.audio.fileUrl ? true : false;
      this.$v.$touch();
      var params = "";
      if (
        !this.$v.$anyError &&
        !this.audioError &&
        !this.audioQuestion1Error &&
        !this.audioQuestion2Error
      ) {
        params = {
          sub_key: this.$route.params[this.parent],
          parent: this.parent,
          name: [],
          answer1: "",
          answer2: "",
          answer3: "",
          answer4: "",
          lead_sentence: leadSentence,
          script,
          audio,
          image: "",
          verb: "",
          answer_correct: [isAnsewr],
          sub_question: {
            question1: {
              answers: question1.answers,
              audio: question1.audio,
              script: question1.script,
              isAnsewr: question1.isAnsewr,
            },
            question2: {
              answers: question2.answers,
              audio: question2.audio,
              script: question2.script,
              isAnsewr: question2.isAnsewr,
            },
          },
          list_answer: {
            sentence_answer: [],
            answer: [],
          },
        };
      }
      return params;
    },
    answersErrors(value) {
      if (value.$dirty && !value.required) return "回答を入力してください。";
      if (value.$dirty && !value.strongAnswers) {
        return "特殊文字以外を入力してください。";
      }
    },
  },
};
</script>
<style scoped>
#Audio {
  height: 40px;
}
</style>